<template>
  <ubi-panel :title="$t('socialPosts.create.initial.title')" v-loading="loadingStatus">
    <p class="text-justify">{{$t('socialPosts.create.initial.subtitle')}}</p>
    <hr>
            <el-row>
              <el-col :lg="24">
                <el-form-item :label="$t('socialPosts.create.initial.libelle')" prop="libellePostInput" class="toto">
                  <div style="margin-top: -38px; margin-left: 120px">
                    <el-tooltip class="item" effect="dark" content="Ce libellé ne sera pas diffusé sur les réseaux sociaux et sera uniquement visible de vous."
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input v-model="post.initial.libelle" @input="updateLibelleInitial"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="24">
                <el-form-item :label="$t('socialPosts.create.initial.textContent')" prop="texteInputInitial">
                  <el-row>
                    <el-col :lg="24" class="text-justify"><h5 style="font-size: 0.8125rem;font-family: 'Open Sans', Helvetica, Arial, sans-serif;line-height: 19.5px" v-html="$t('socialPosts.create.initial.textContentInfo')"></h5>
                    </el-col>
                  </el-row>
                  <div v-if="!post.initial.libelle">
                    <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.IAButtonDisabled')" placement="bottom">
                      <el-button  size="mini" type="success" @click="openModalIAInitial()" :disabled="!post.initial.libelle" style="margin-bottom: 15px;">{{$t('socialPosts.create.redactWithAi')}}</el-button>
                    </el-tooltip>
                  </div>
                  <div v-else>
                    <el-button  size="mini" type="success" @click="openModalIAInitial()" style="margin-bottom: 15px;">{{$t('socialPosts.create.redactWithAi')}}</el-button>
                  </div>
                  <div class="textarea-with-emojis" >
                    <el-input :rows="8"
                              type="textarea"
                              v-model="post.initial.inputText"
                              @input="updateTexteInitial"
                              ref="textareaPostEditoInitial"
                              >
                    </el-input>

                    <div>
                      <Emoji @addEmoji="addEmoji($event)" class="box-emojis"/>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

        <el-row>
          <el-col :lg="24">
            <el-form-item :label="$t('socialPosts.create.medias') + ' *'">
            <post-edito-photos-upload 
              :post="post"
              network="initial"
              :desactiver-champ="false"
            ></post-edito-photos-upload>
            </el-form-item>
          </el-col>
        </el-row>

    <div>
      <div>
        <span><strong>{{ $t('posts.networks.videoEditoTitre') }}</strong></span>
        <el-tooltip class="item" effect="dark" :content="$t('posts.networks.videoEditoHelp')" placement="bottom">
          <em class="el-icon-question"></em>
        </el-tooltip>
      </div>
      <div style="font-size: 0.8em">{{ $t('posts.networks.videoEditoSousTitre') }}</div>
    </div>
    <el-form-item :error="inputError">
      <el-row>
        <el-col :span="24">
          <el-input v-model="post.initial.linkToVideo" @change="updateLinkToVideo" type="url"></el-input>
        </el-col>
      </el-row>
    </el-form-item>
  </ubi-panel>
</template>

<script>

import Emoji from '@/components/emojis/Emoji'
import { Upload } from 'element-ui'
import { mapMutations, mapState } from 'vuex'
import PostEditoPhotosUpload from '@/pages/socialNetworks/components/PostEditoPhotosUpload'
import {$t} from "@/i18n";
export default {
  name: 'PostEditoCreatePublicationInitiale',
  components: {
    Emoji,
    PostEditoPhotosUpload
  },
  props: ['post'],
  data () {
    return {
      loadingStatus: false,
      inputError: ''
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial', ['watcherNewPic', 'draftButtonAvailable', 'publishButtonAvailable']),
    texteInput: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.initial.inputText
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/updateInputTextInitial', value)
      }
    },
    libellePostInput: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.initial.libelle
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/updateLibelleInitial', value)
      }
    }
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial', ['setModalIA', 'setWatcherNewPic', 'setNetworkClicked']),
    openModalIAInitial () {
      this.setNetworkClicked('initial')
      this.setModalIA(true)
    },
    addEmoji (emoji) {
      this.emojiDisplay = true
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaPostEditoInitial.$el.querySelector('.el-textarea__inner')
      let cursorIndex = textarea.selectionEnd
      if (textarea.innerHTML === '' && !this.post.initial.inputText) {
        textarea.innerHTML += insertText
      }
      if (this.post.initial.inputText) {
        this.post.initial.inputText = this.post.initial.inputText.substring(0, cursorIndex) + insertText + this.post.initial.inputText.substring(cursorIndex)
      } else {
        this.post.initial.inputText = insertText
      }

      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    updateLibelleInitial (value) {
      this.$store.commit('socialPostsCreationPostEditorial/updateLibelleInitial', value)
      this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
      this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
    },
    updateTexteInitial (value) {
      this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
      this.$store.commit('socialPostsCreationPostEditorial/updateInputTextInitial', value)
      this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
    },
    updateLinkToVideo (value) {
      this.inputError = ''
      if (!value || this.urlIsValid(value)) {
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      } else {
        this.inputError = $t('posts.networks.videoUrlError')
        this.$emit('updateValue', 'setError', this.inputError)
        this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', true)
        this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', true)
        this.$message({ message: $t('posts.networks.videoUrlError'), type: 'error', duration: 10000 })
        return false
      }
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
          (urlVideo.hostname.indexOf('youtube') === -1) &&
          (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    }
  }
}
</script>

<style scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0px;
  right: -5px;
  z-index: 3;
}
.el-form-item__label {
  color: #184a56;
  line-height: 1.5;
  font-weight: bold !important;
}
</style>
